// components
import CommonForm from "../Common/CommonForm";
import CommonActionModal from "../Common/CommonActionModal";
import BaseApi from "../../utils/BaseApi";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TableViewIcon from "@mui/icons-material/TableView";


class EstimationPhaseCreate extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            button: {
                icon: AddCircleIcon,
                label: 'Вставить этап',
                color: 'neutral',
                variant: 'plain',
            },
            ready: true,
            flat: true,
        })
    }

    async beforeModalOpen(){
        let formFields = await this.retrieveFields()
        return {
            modalLabel: 'Добавление этапа трудоемкости',
            modalIcon: TableViewIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
        }
    }

    async retrieveFields(){
        const url = `estimation_phase/create_form/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        return(response.data)
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        formDataObj.revision_fk = this.props.revisionId;
        formDataObj.opportunity = this.props.opportunityId;
        formDataObj.order = this.props.order
        const url = `estimation_phase/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            await this.props.callBack();
            this.setModalOpenFalse();
        }
        return response
    }
}

export default EstimationPhaseCreate
